type Metadata = Record<string, unknown> | undefined;

interface IsNoindexEnabledOptions {
  pageMetadata?: Metadata;
  siteMetadata?: Metadata;
}

const isNoindexEnabled = ({ pageMetadata, siteMetadata }: IsNoindexEnabledOptions): boolean => {
  return pageMetadata?.noindex_enabled === true || siteMetadata?.noindex_enabled === true;
};

export default isNoindexEnabled;
